export default class MainNavigation {
  constructor(element) {
    this.level2Items = element.querySelectorAll('.js-menu-level-2')
    this.level3Items = element.querySelectorAll('.js-menu-level-3')

    if (!this.level2Items.length || !this.level3Items) {
      return
    }

    this.init()
  }

  init() {
    for (let i = 0; i < this.level2Items.length; i++) {
      const element = this.level2Items[i]
      const menu = element.dataset.menu

      element.addEventListener('mouseenter', () => this.showLevel3(menu))
    }
  }

  showLevel3(menu) {
    if (!menu) {
      return
    }

    for (let i = 0; i < this.level2Items.length; i++) {
      const element = this.level2Items[i]
      const elementMenu = element.dataset.menu

      if (elementMenu === menu) {
        element.classList.add('is--active')
      } else {
        element.classList.remove('is--active')
      }
    }

    for (let i = 0; i < this.level3Items.length; i++) {
      const element = this.level3Items[i]
      const elementMenu = element.dataset.menu

      if (elementMenu === menu) {
        element.classList.add('is--active')
      } else {
        element.classList.remove('is--active')
      }
    }
  }
}
